import NewAgreementThirdPage from './NewAgreementThirdPage';

export default NewAgreementThirdPage;
